<template>
    <div class="container-fluid">

        <b-row v-if="user_admin">
            <b-col md="4">

                <div class="links">
                    <div class="link-title"><i class="fa fa-gamepad block-title"></i>愛管侍</div>
                    <div class="link-item" @click="$config.goTo_Iguanshi('home')">愛管侍首頁 IGuanShi Home</div>
                </div>

            </b-col>

            <b-col md="4">

                <div class="links">
                    <div class="link-title"><i class="fa fa-industry block-title"></i>專案相關</div>
                    <router-link class="link-item" :to="{ name: 'List Projects' }">專案列表 All Projects</router-link>
                    <router-link class="link-item" :to="{ name: 'New Project' }">新增專案 New Project</router-link>
                </div>

            </b-col>

            <b-col md="4">

                <div class="links">
                    <div class="link-title"><i :class="$tools.style.classIcon('wand', 'block-title')"></i>裝置相關</div>
                    <router-link class="link-item" :to="{ name: 'List Devices' }">裝置列表 All Devices</router-link>
                    <router-link class="link-item" :to="{ name: 'New Device' }">新增裝置 New Device</router-link>
                    <router-link class="link-item" :to="{ name: 'Edit ParamSets' }">拼盤廚房 (感測參數範本) Edit ParamSets</router-link>
                    <router-link class="link-item" :to="{ name: 'Device Map' }">裝置地圖 Device Map</router-link>
                </div>

            </b-col>

            <b-col md="4">

                <div class="links">
                    <div class="link-title"><i :class="$tools.style.classIcon('gateway', 'block-title')"></i>閘道器相關</div>
                    <router-link class="link-item" :to="{ name: 'List Gateways' }">阿龜閘道器列表 All Gateways</router-link>
                    <router-link class="link-item" :to="{ name: 'New Gateway' }">新增阿龜閘道器 New Gateway</router-link>
                </div>

            </b-col>

            <b-col md="4">

                <div class="links">
                    <div class="link-title"><i :class="$tools.style.classIcon('accesspoint', 'block-title')"></i>無線熱點相關</div>
                    <router-link class="link-item" :to="{ name: 'List AccessPoints' }">無線熱點列表 All AccessPoints</router-link>
                    <router-link class="link-item" :to="{ name: 'New AccessPoint' }">新增無線熱點 New AccessPoint</router-link>
                </div>

            </b-col>

            <b-col md="4">

                <div class="links">
                    <div class="link-title"><i class="fa fa-user block-title"></i>工具類</div>
                    <router-link class="link-item" :to="{ name: 'Kitchen' }">加鹽廚房 Kitchen</router-link>
                    <router-link class="link-item" :to="{ name: 'QRCode' }">QR Code</router-link>
                    <router-link class="link-item" :to="{ name: 'Search Cropperiods' }">期作查詢工具 Search Cropperiods</router-link>
                    <a class="link-item" :href="urls.device_helper" target="_blank">
                        裝置小幫手 Device Helper
                        <i class="fa fa-external-link ml-2"></i>
                    </a>
                </div>

            </b-col>

            <b-col md="4">

                <div class="links">
                    <div class="link-title"><i class="fa fa-user block-title"></i>使用者相關</div>
                    <router-link class="link-item" :to="{ name: 'List Users' }">使用者列表 All Users</router-link>
                    <router-link class="link-item" :to="{ name: 'Register' }">註冊 Register</router-link>
                    <router-link class="link-item" :to="{ name: 'Batch Register' }">批次註冊帳號 Batch Register</router-link>
                    <router-link class="link-item" :to="{ name: 'Log Users' }">近期操作 Recent Logs</router-link>
                    <router-link class="link-item" :to="{ name: 'Log Summary' }">操作次數統計 Logs Summary</router-link>
                    <router-link class="link-item" :to="{ name: 'Log Charts' }">操作次數統計圖表 Logs Charts</router-link>
                </div>

            </b-col>

            <b-col md="4">

                <div class="links">
                    <div class="link-title"><i class="fa fa-graduation-cap block-title"></i>標準設定相關</div>
                    <router-link class="link-item" :to="{ name: 'Alert Editor' }">預警 - 規則設定 Alert Editor</router-link>
                    <router-link class="link-item" :to="{ name: 'Status Work Editor' }" v-if="user_email == 'iris@beehivedt.com'">
                        預警 - 建議工作設定 Status Work Editor<br>[ 未完成功能先隱藏 ]
                    </router-link>
                </div>

            </b-col>

            <b-col md="4">

                <div class="links">
                    <div class="link-title"><i class="fa fa-exclamation-circle block-title"></i>列表類</div>
                    <router-link class="link-item" :to="{ name: 'List Stress Alerts' }">預警列表 Top 100 Stress Alerts</router-link>
                </div>

            </b-col>

        </b-row>

    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {

    computed: {
        ...mapState({
            'user_admin': state => state.user.is_admin,
            'user_email': state => state.user.email,
        }),

        urls ()
        {
            let _hostname = location.hostname

            // agri device helper
            let _device_helper_url = 'https://cloud.agriweather.online/device-helper'
            if ( _hostname == 'localhost' ) _device_helper_url = 'https://xlab.agriweather.online/device-helper'
            else                            _device_helper_url = location.origin + '/device-helper'

            return {
                device_helper: _device_helper_url,
            }
        },
    }
}
</script>


<style lang="scss" scoped>

</style>

